import { LeagueType } from '@plvs/graphql/generated'

// consts

export const LeagueTypeMap: Record<LeagueType, string> = {
  [LeagueType.Sanctioned]: 'Sanctioned',
  [LeagueType.Unsanctioned]: 'Unsanctioned',
}
